import { apolloApi } from "@/shared/api";

interface PersonnelQueryParams {
  offset: number;
  limit: number;
  sortColumn: string;
  sortDir: string;
  currentTeamIds?: number[];
}

export async function personnelLoader({
  offset,
  limit,
  sortColumn,
  sortDir,
  currentTeamIds,
}: PersonnelQueryParams) {
  const response = await apolloApi.getAllPersonnel({
    offset,
    limit,
    sortColumn,
    sortDir,
    currentTeamIds,
  });
  return response;
}

export async function personnelByIdLoader({ id }: { id: number }) {
  if (!id) return;

  const response = await apolloApi.getPersonnelById(id);
  return response.personnel;
}
